function Common() {
  function gallarySlideHandler() {
    const $thumbnailMains = document.querySelectorAll(".js-thumbnail-main");
    const $thumbnailImg = document.querySelectorAll(".js-thumbnail-main__splide-img");
    const $thumbnailCarousels = document.querySelectorAll(".js-thumbnail-carousel");
    $thumbnailMains.forEach(($thumbnailMain, index) => {
      const $thumbnailCarousel = $thumbnailCarousels[index];
      if ($thumbnailMain._splideInstance && $thumbnailMain._splideInstance.state.is(3)) {
        return;
      }
      if ($thumbnailMain._splideInstance) {
        $thumbnailMain._splideInstance.destroy();
      }
      const $main = new Splide($thumbnailMain, {
        type: "fade",
        // フェード
        rewind: true,
        // スライダーの終わりまで行ったら先頭に巻き戻す
        pagination: false,
        // ページネーション非表示
        arrows: true
        // 矢印非表示
      });
      const $thumbnails = new Splide($thumbnailCarousel, {
        type: "loop",
        perPage: 4,
        pagination: false,
        // ページネーション非表示
        isNavigation: true,
        // 他のスライダーのナビゲーションとしてそれぞれのスライドをクリック可能にする
        arrows: false,
        gap: "15px",
        mediaQuery: "min",
        focus: "center",
        breakpoints: {
          768: {
            gap: "25px"
          }
        }
      });
      $thumbnailImg.forEach((thumbnailImg) => {
        thumbnailImg.addEventListener("click", () => {
          $main.go("+1");
        });
      });
      $main.sync($thumbnails);
      $main.mount();
      $thumbnailMain._splideInstance = $main;
      $thumbnails.mount();
      $thumbnailMain._splideInstance = $thumbnails;
    });
  }
  function mvSlideHandler() {
    const $mvSlider = document.querySelectorAll(".js-mv-slider");
    $mvSlider.forEach(($thumbnailMain) => {
      if ($thumbnailMain._splideInstance && $thumbnailMain._splideInstance.state.is(3)) {
        return;
      }
      if ($thumbnailMain._splideInstance) {
        $thumbnailMain._splideInstance.destroy();
      }
      const mvSplide = new Splide($thumbnailMain, {
        direction: "ttb",
        // スライダーの方向を指定
        // heightRatio: 1.7, // スライドの高さをスライダーの幅に対する割合で指定
        height: "97vh",
        wheel: true,
        // マウスホイールによるスライダーの移動を有効にする
        waitForTransition: false,
        // スライダーが移動中にも操作を受け付ける
        arrows: false,
        speed: 750,
        easing: "cubic-bezier(0.25, 1, 0.5, 1)"
      });
      mvSplide.mount();
      $thumbnailMain._splideInstance = mvSplide;
      let startY = 0;
      let isLastSlide = false;
      let touchStarted = false;
      mvSplide.on("moved", (newIndex) => {
        isLastSlide = newIndex === mvSplide.length - 1;
      });
      mvSplide.on("mounted", () => {
        isLastSlide = mvSplide.index === mvSplide.length - 1;
      });
      if (mvSplide.length === 1) isLastSlide = true;
      const sliderElement = $thumbnailMain;
      sliderElement.addEventListener("touchstart", (e) => {
        if (isLastSlide) {
          startY = e.touches[0].clientY;
          touchStarted = true;
        }
      }, { passive: true });
      sliderElement.addEventListener("touchmove", (e) => {
        if (!touchStarted || !isLastSlide) return;
        const currentY = e.touches[0].clientY;
        const deltaY = currentY - startY;
        if (deltaY < 10) {
          exitSliderArea();
          touchStarted = false;
        }
      }, { passive: true });
      sliderElement.addEventListener("touchend", () => {
        touchStarted = false;
      }, { passive: true });
      sliderElement.addEventListener("wheel", (e) => {
        if (isLastSlide && e.deltaY > 0) {
          exitSliderArea();
        }
      }, { passive: true });
      function exitSliderArea() {
        var _a;
        const nextSection = (_a = document.querySelector(".js-mv-slider-section")) == null ? void 0 : _a.nextElementSibling;
        if (nextSection) {
          nextSection.scrollIntoView({ behavior: "smooth" });
        }
      }
    });
  }
  function galleryModal() {
    const $galleryItemList = document.querySelectorAll(".js-gallery-item");
    const $SliderItemList = document.querySelectorAll(".c-slider-pc__item");
    const $sliderPc = document.querySelector(".js-slider-pc");
    if (!$galleryItemList || !$SliderItemList || !$sliderPc) return;
    const option = {
      type: "fade",
      pagination: false
    };
    const splideInstance = new Splide($sliderPc, option).mount();
    splideInstance.on("mounted move", function() {
      const current = splideInstance.index - 1;
      $SliderItemList.forEach((item, idx) => {
        if (current === idx) {
          item.classList.add("is-active");
        }
      });
    });
    $galleryItemList.forEach((item, idx) => {
      item.addEventListener("click", () => {
        const targetId = idx;
        splideInstance.go(targetId);
      });
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        MicroModal.close("slider-pc");
      }
    });
    $galleryItemList.forEach((slideItem) => slideItem.addEventListener("click", () => MicroModal.show("slider-pc")));
  }
  gallarySlideHandler();
  mvSlideHandler();
  galleryModal();
}
let events = [];
if (Shopify && Shopify.designMode) {
  events = [
    "shopify:section:load",
    "shopify:section:unload",
    "shopify:section:select",
    "shopify:section:deselect",
    "shopify:inspector:reorder",
    "shopify:inspector:activate",
    "shopify:inspector:deactivate"
  ];
} else {
  events = [
    "DOMContentLoaded"
  ];
}
events.forEach(
  (event) => window.addEventListener(event, Common)
);
